import { Box } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const ProductDetailFlowContainer = Box.withConfig({
  flex: 1,
  width: 'full',
});

export const productDetailFlowContainerStyles: any = {
  flex: 1,
  width: '100%',
};

export const ProductDetailFlowContent = Box.withConfig({
  flex: 1,
  width: 'full',
});

export const ProductDetailFlowHeaderContainer = Box.withConfig({
  width: 'full',
  height: '$16',
  justifyContent: 'center',
  alignItems: 'center',
});

export const ProductDetailFlowFooterContainer = Box.withConfig({
  width: 'full',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: primitive.$white,
});
